export default "__VITE_ASSET__Bd_B9_dT__"